import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toArray from "@babel/runtime/helpers/toArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
/**
 * If you are displaying an image from any DB object on any client it should be transformed.
 *
 * You probably either want to use [[optimizeProductImageUrl]] or [[optimizeImageUrl]].
 *
 * ONLY transform **product** or **product option** images using [[optimizeProductImageUrl]]!
 *
 * Details about options can be found in [[IOptimizeImageOptions]]
 *
 * @packageDocumentation
 */
import { ALL_IMAGE_CROPPING_PREFIX, AUTO_IMAGE_CROP_APPAREL_TAG_PREFIX, AUTO_IMAGE_CROP_SQUARE_TAG_PREFIX } from "@faire/web--source/common/images/cropUtils/autoImageCropTagPrefix";
import { MANUAL_IMAGE_CROP_APPAREL_TAG_PREFIX, MANUAL_IMAGE_CROP_TAG_PREFIX } from "@faire/web--source/common/images/cropUtils/manualImageCropTagPrefix";
import { removeImageCropTag } from "@faire/web--source/common/images/cropUtils/removeImageCropTag";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import clone from "lodash/clone";
import isNil from "lodash/isNil";
import isObject from "lodash/isObject";
import merge from "lodash/merge";
import startsWith from "lodash/startsWith";
import qs from "query-string";
import { logError } from "../logging";
import { assignOptimizeImageUrlForCacheHit, getSettingOptimizeImageUrlForCacheHit } from "../settings/getSettingOptimizeImageUrlForCacheHit";
import { assignOptimizeImageUrlForCacheHitBrand, getSettingOptimizeImageUrlForCacheHitBrand } from "../settings/getSettingOptimizeImageUrlForCacheHitBrand";
import { hasErrorMessage } from "../typescriptUtils";
var defaultDPR = 1;
/**
 * Sets the DPR for a session. Should only be set once per repo.
 *
 * If you want to set the DPR for a specific image see [[IOptimizeImageOptions.dprOverride]]
 */
export var setImageDPR = function setImageDPR(dpr) {
  defaultDPR = dpr ? Math.round(dpr * 2) / 2 : 1;
};
// Test if given URL is a Shopify CDN url
var isShopifyImageUrl = function isShopifyImageUrl(url) {
  return /cdn\.shopify\.com\//.test(url);
};
// Test if given URL is a fastly/internal faire CDN url
export var isFastly = function isFastly(url) {
  return /cdn\.faire\.com\//.test(url) || /cdn\.faire-stage\.com\//.test(url);
};
// Test if given URL is a .tiff url
var isTiff = function isTiff(url) {
  return /\.tiff?($|\?)/.test(url);
};
/**
 * Useful if different UI handles transformable image vs something else
 */
export var isTransformableImageUrl = function isTransformableImageUrl(image) {
  return !!image && !!image.url && !isTiff(image.url) && isFastly(image.url);
};
var isHexColor = function isHexColor(color) {
  return color[0] === "#";
};
var getShopifyImageUrl = function getShopifyImageUrl(imageUrl, options) {
  var _imageUrl$split = imageUrl.split("?"),
    _imageUrl$split2 = _toArray(_imageUrl$split),
    pathName = _imageUrl$split2[0],
    queries = _imageUrl$split2.slice(1);
  var params = qs.parse(queries.join("?"));
  var width = options.width && options.width > 0 ? options.width.toString() : undefined;
  var height = options.height && options.height > 0 ? options.height.toString() : undefined;
  if (width) {
    params.width = width;
  }
  if (height) {
    params.height = height;
  }
  return "".concat(pathName, "?").concat(qs.stringify(params, {
    encode: false
  }));
};
// eslint-disable-next-line complexity
var getFastlyUrl = function getFastlyUrl(imageUrl, options, isSSR) {
  if (!isFastly(imageUrl)) {
    return imageUrl;
  }
  var _imageUrl$split3 = imageUrl.split("?"),
    _imageUrl$split4 = _toArray(_imageUrl$split3),
    pathName = _imageUrl$split4[0],
    queries = _imageUrl$split4.slice(1);
  var params = qs.parse(queries.join("?"));
  params.dpr = String(getDpr(options, isSSR));
  if (options.useLossless) {
    params.format = "png";
  } else if (options.maintainTransparency) {
    params.format = null;
  } else {
    params.format = "jpg";
  }
  var width = options.width && options.width > 0 ? options.width.toString() : undefined;
  var height = options.height && options.height > 0 ? options.height.toString() : undefined;
  if (width) {
    params.width = width;
  }
  if (height) {
    params.height = height;
  }
  var serverOnly = options.serverOnly;
  if (options.resizeMethod) {
    // Default resizeMethod is fit, if you override, you needs to
    // provide both width and height
    if (!width || !height) {
      logError(new Error("getFastlyUrl - resizing requires width and height"), {
        data: {
          imageUrl: imageUrl,
          options: options
        },
        serverOnly: serverOnly
      });
    }
    if (options.resizeMethod === "fit") {
      params.fit = "bounds";
    } else if (options.resizeMethod === "fill") {
      params.fit = "crop";
    } else if (options.resizeMethod === "pad") {
      params.fit = "bounds";
      params.canvas = "".concat(width, ":").concat(height);
    }
  }
  if (options.crop) {
    var _options$crop = options.crop,
      _width = _options$crop.width,
      _height = _options$crop.height,
      x = _options$crop.x,
      y = _options$crop.y,
      smartSquare = _options$crop.smartSquare;
    if (smartSquare) {
      params.precrop = "1:1,smart";
      if (!isNil(_width) || !isNil(_height) || !isNil(x) || !isNil(y)) {
        logError(new Error("getFastlyUrl - crop options includes options that will be overriden"), {
          data: {
            imageUrl: imageUrl,
            options: options
          },
          serverOnly: serverOnly
        });
      }
    } else if (!isNil(_width) && !isNil(_height) && !isNil(x) && !isNil(y)) {
      // https://developer.fastly.com/reference/io/crop/
      // CROP_FAIL_SAFE is passed to ensure that the image loads
      // even if the crop param is malformed.
      // If the crop param is malformed the crop will not be applied.
      // Currently we only use manual crop on brand headers,
      // if we use that image anywhere else the manual crop might not be applied.
      // If we want to preserve the manual crop we should look into
      // changing from using fixed crop values to using relative values
      // see: https://github.com/Faire/web-common/pull/222#pullrequestreview-591312668
      var CROP_FAIL_SAFE = "safe";
      if (_width > 0 && _height > 0) {
        params.precrop = "".concat(_width, ",").concat(_height, ",x").concat(x, ",y").concat(y, ",").concat(CROP_FAIL_SAFE);
      } else {
        logError(new Error("getFastlyUrl - crop options is malformed"), {
          data: {
            imageUrl: imageUrl,
            options: options
          },
          serverOnly: serverOnly
        });
      }
    } else {
      logError(new Error("getFastlyUrl - crop options have missing props"), {
        data: {
          imageUrl: imageUrl,
          options: options
        },
        serverOnly: serverOnly
      });
    }
  }
  if (!isNil(options.quality)) {
    params.quality = "".concat(options.quality);
  }
  if (options.background) {
    if (isHexColor(options.background)) {
      var hexColor = options.background.slice(1);
      params["bg-color"] = "".concat(hexColor);
    } else {
      logError(new Error("getFastlyUrl - background option is invalid"), {
        data: {
          imageUrl: imageUrl,
          options: options
        },
        serverOnly: serverOnly
      });
    }
  }
  return "".concat(pathName, "?").concat(qs.stringify(params, {
    encode: false
  }));
};
var RESIZE_METHOD_TAG_PREFIX = "cloudinary_crop_";
var getResizeMethodTag = function getResizeMethodTag() {
  var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var resizeMethodTag = Array.isArray(tags) && tags.find(function (tag) {
    return startsWith(tag, RESIZE_METHOD_TAG_PREFIX);
  });
  if (resizeMethodTag) {
    return resizeMethodTag.replace(new RegExp("^".concat(RESIZE_METHOD_TAG_PREFIX)), "");
  }
  return undefined;
};
//TODO: change this name to include auto cropped image.
export var isManuallyCroppedImage = function isManuallyCroppedImage(image) {
  return !!image && !!getCropTagParams(image);
};
export var isAutoCroppedApparelImage = function isAutoCroppedApparelImage(image) {
  var _image$tags;
  var apparelTag = image === null || image === void 0 ? void 0 : (_image$tags = image.tags) === null || _image$tags === void 0 ? void 0 : _image$tags.find(function (tag) {
    return tag.startsWith(AUTO_IMAGE_CROP_APPAREL_TAG_PREFIX);
  });
  return isProductImage(image) && !!apparelTag;
};
export var isAutoCroppedSquareImage = function isAutoCroppedSquareImage(image) {
  var _image$tags2;
  var squareTag = image === null || image === void 0 ? void 0 : (_image$tags2 = image.tags) === null || _image$tags2 === void 0 ? void 0 : _image$tags2.find(function (tag) {
    return tag.startsWith(AUTO_IMAGE_CROP_SQUARE_TAG_PREFIX);
  });
  return isProductImage(image) && !!squareTag;
};
var isProductImage = function isProductImage(image) {
  var _image$tags3;
  return !!image && !!image.url && !!((_image$tags3 = image.tags) !== null && _image$tags3 !== void 0 ? _image$tags3 : []).find(function (tag) {
    return ["Hero", "Product"].includes(tag);
  });
};
export var getCropTagParams = function getCropTagParams(image) {
  //there should only exist one crop tag
  var cropTag = image !== undefined && image.url !== undefined && Array.isArray(image.tags) && image.tags.slice()
  // make sure manual crop takes precedence
  .sort().reverse().find(function (tag) {
    return ALL_IMAGE_CROPPING_PREFIX.find(function (prefix) {
      return tag.startsWith(prefix);
    });
  });
  if (cropTag) {
    try {
      var allCropPrefixPattern = new RegExp(ALL_IMAGE_CROPPING_PREFIX.join("|"), "g");
      var crop = JSON.parse(cropTag.replace(allCropPrefixPattern, ""));
      if (crop && (!crop.width || !crop.height || isNil(crop.x) || isNil(crop.y))) {
        var _image$url;
        var error = new Error("getFastlyUrl - crop option is malformed");
        logError(error, {
          data: {
            image: image,
            crop: crop
          },
          fingerprint: [error.message, (_image$url = image.url) !== null && _image$url !== void 0 ? _image$url : "no image url provided"]
        });
      } else {
        return crop;
      }
    } catch (error) {
      var _image$url2;
      var fingerprint = [];
      if (isObject(error) && hasErrorMessage(error)) {
        fingerprint.push(error.message);
      } else {
        fingerprint.push("no error message provided");
      }
      fingerprint.push((_image$url2 = image.url) !== null && _image$url2 !== void 0 ? _image$url2 : "no image url provided");
      logError(new Error("getCropTagParams - manual image crop tag is invalid"), {
        data: {
          cropTag: cropTag
        },
        fingerprint: fingerprint
      });
    }
  }
  return undefined;
};
/**
 * Transform image urls to resize and crop images for use on the client
 *
 * All product images should be encoded using [[optimizeProductImageUrl]]
 */
export var optimizeImageUrl = function optimizeImageUrl(image, isSSR) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var serverOnly = options.serverOnly;
  if (!image || !image.url) {
    logError(new Error("optimizeImageUrl - invalid ImageOptions argument"), {
      data: {
        image: image,
        options: options
      },
      serverOnly: serverOnly
    });
    return image ? image.url : undefined;
  }
  if (isShopifyImageUrl(image.url)) {
    return getShopifyImageUrl(image.url, options);
  }
  if (!isTransformableImageUrl(image)) {
    // If not transformable short circuit
    return image.url;
  }
  var imageConfig = clone(options);
  var resizeMethodTag = getResizeMethodTag(image.tags);
  if (resizeMethodTag && !options.ignoreResizeTag) {
    imageConfig.resizeMethod = resizeMethodTag;
    if (resizeMethodTag === "pad" && !options.background) {
      imageConfig.background = "#fff";
    }
  }
  var cropTagParams = getCropTagParams(image);
  if (cropTagParams) {
    var _imageConfig$crop;
    if (!((_imageConfig$crop = imageConfig.crop) !== null && _imageConfig$crop !== void 0 && _imageConfig$crop.smartSquare)) {
      imageConfig.crop = cropTagParams;
    }
  }
  if (Array.isArray(image.tags) && image.tags.indexOf("prefer_lossless") >= 0) {
    imageConfig.useLossless = true;
  }
  return getFastlyUrl(image.url, imageConfig, isSSR);
};
var PRODUCT_DEFAULT_OPTIONS = {
  width: 350,
  height: 350,
  resizeMethod: "fill"
};
/**
 * # Optimize a IProduct or IProductOption IImage
 *
 * Product images have special cropping logic built into the IImage data.
 * They also default to being squared.
 * This function obeys these constraints and allows overrides if needed.
 *
 * This is the **only function** that should be used for optimizing product images.
 */
export var optimizeProductImageUrl = function optimizeProductImageUrl(image, isSSR, dimension) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var productImageDefaults = _objectSpread(_objectSpread({}, dimension ? {
    width: dimension,
    height: dimension
  } : {}), options.maintainTransparency ? {} : {
    background: "#FFFFFF"
  });
  //To enable auto crop XP for all product images with auto crop tag,
  //check if tag exist first and assign setting after.
  if (isAutoCroppedSquareImage(image)) {
    //This image might have two tags: square and apparel, remove the apparel one.
    var _tags = removeImageCropTag(image.tags, [AUTO_IMAGE_CROP_APPAREL_TAG_PREFIX, MANUAL_IMAGE_CROP_APPAREL_TAG_PREFIX]);
    var imageWithSquareCrop = IImage.build(_objectSpread(_objectSpread({}, image), {}, {
      tags: _tags
    }));
    return optimizeImageUrl(imageWithSquareCrop, isSSR, merge({}, PRODUCT_DEFAULT_OPTIONS, productImageDefaults, options, {
      ignoreResizeTag: true
    }));
  }
  if (!image || !image.url) {
    return;
  }
  //remove auto crops outside the experiment, keep manual square tag
  var tags = removeImageCropTag(image.tags, [AUTO_IMAGE_CROP_SQUARE_TAG_PREFIX, AUTO_IMAGE_CROP_APPAREL_TAG_PREFIX, MANUAL_IMAGE_CROP_APPAREL_TAG_PREFIX]);
  var imageWithoutAutoCrop = IImage.build(_objectSpread(_objectSpread({}, image), {}, {
    tags: tags
  }));
  return optimizeImageUrl(imageWithoutAutoCrop, isSSR, transformOptionsForCacheHits(merge({}, PRODUCT_DEFAULT_OPTIONS, productImageDefaults, options), isSSR));
};
/** Quick method for cropping image into a rectangle  */
export var optimizeImageUrlFillRectangle = function optimizeImageUrlFillRectangle(image, isSSR, width, height) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return optimizeImageUrl(image, isSSR, _objectSpread(_objectSpread({}, options), {}, {
    width: width,
    height: height,
    resizeMethod: "fill"
  }));
};
/** Quick method for cropping image into a square  */
export var optimizeImageUrlFillSquare = function optimizeImageUrlFillSquare(image, isSSR, dimension) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return optimizeImageUrl(image, isSSR, _objectSpread(_objectSpread({}, options), {}, {
    width: dimension,
    height: dimension,
    resizeMethod: "fill"
  }));
};
/** Quick method for resizing image by width */
export var optimizeImageUrlWidth = function optimizeImageUrlWidth(image, isSSR, width) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return optimizeImageUrl(image, isSSR, _objectSpread(_objectSpread({}, options), {}, {
    width: width
  }));
};
/** Quick method for resizing image by height */
export var optimizeImageUrlHeight = function optimizeImageUrlHeight(image, isSSR, height) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return optimizeImageUrl(image, isSSR, _objectSpread(_objectSpread({}, options), {}, {
    height: height
  }));
};
/** Quick method for getting a vertical product image
 * Vertical product images' standard aspect ratio is 3/4
 *
 * Image retains its aspect ratio while filling the entire 3:4 container, where
 * dimension is the width of the container. If the aspect ratio of the image is
 * not 3:4, the image will be cropped to fit.
 */
var VERTICAL_ASPECT_RATIO = 3 / 4;
export var optimizeProductImageUrlFillVertical = function optimizeProductImageUrlFillVertical(image, isSSR, width) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var productImageDefaults = _objectSpread(_objectSpread({}, {
    width: width,
    height: width / VERTICAL_ASPECT_RATIO
  }), options.maintainTransparency ? {} : {
    background: "#FFFFFF"
  });
  //To enable auto crop XP for all product images with auto crop tag,
  //check if tag exist first and assign setting after.
  if (isAutoCroppedApparelImage(image)) {
    //This image might have two tags: square and apparel, remove the square one.
    var _tags2 = removeImageCropTag(image.tags, [AUTO_IMAGE_CROP_SQUARE_TAG_PREFIX, MANUAL_IMAGE_CROP_TAG_PREFIX]);
    var imageWithApparelCrop = IImage.build(_objectSpread(_objectSpread({}, image), {}, {
      tags: _tags2
    }));
    return optimizeImageUrl(imageWithApparelCrop, isSSR, merge({}, PRODUCT_DEFAULT_OPTIONS, productImageDefaults, options, {
      ignoreResizeTag: true
    }));
  }
  //remove auto crops outside the experiment, keep manual apparel crop
  var tags = removeImageCropTag(image.tags, [AUTO_IMAGE_CROP_SQUARE_TAG_PREFIX, AUTO_IMAGE_CROP_APPAREL_TAG_PREFIX, MANUAL_IMAGE_CROP_TAG_PREFIX]);
  var imageWithoutAutoCrop = IImage.build(_objectSpread(_objectSpread({}, image), {}, {
    tags: tags
  }));
  var doesExistManualApparelTag = tags.find(function (tag) {
    return tag.startsWith(MANUAL_IMAGE_CROP_APPAREL_TAG_PREFIX);
  });
  if (doesExistManualApparelTag) {
    return optimizeImageUrl(imageWithoutAutoCrop, isSSR, transformOptionsForCacheHits(merge({}, PRODUCT_DEFAULT_OPTIONS, productImageDefaults, options, {
      ignoreResizeTag: true
    }), isSSR));
  }
  return optimizeProductImageUrl(imageWithoutAutoCrop, isSSR, width, _objectSpread(_objectSpread({}, options), {}, {
    height: width / VERTICAL_ASPECT_RATIO,
    resizeMethod: "fill",
    ignoreResizeTag: true
  }));
};
function multiplyDprAndRoundUp(value, dpr) {
  var TINY_IMAGE_SIZE = 60;
  if (value * dpr <= TINY_IMAGE_SIZE) {
    /*
     * Return a tiny image size to support incremental loading (ie. displaying
     * a low-resolution image while the full image is downloading).
     */
    return TINY_IMAGE_SIZE;
  }
  var MULTIPLE = 360;
  dpr = Math.min(3, Math.max(1, dpr));
  return Math.round(Math.ceil(value * dpr / MULTIPLE) * MULTIPLE);
}
function transformOptionsForCacheHits(options, isSSR) {
  if (!options.serverOnly) {
    assignOptimizeImageUrlForCacheHit();
    assignOptimizeImageUrlForCacheHitBrand();
  }
  if (!getSettingOptimizeImageUrlForCacheHit() && !getSettingOptimizeImageUrlForCacheHitBrand()) {
    return options;
  }
  var dpr = getDpr(options, isSSR);
  var width = options.width,
    height = options.height;
  if (width && height) {
    var ratio = height / width;
    width = multiplyDprAndRoundUp(width, dpr);
    height = Math.round(width * ratio);
  } else if (width) {
    width = multiplyDprAndRoundUp(width, dpr);
  } else if (height) {
    height = multiplyDprAndRoundUp(height, dpr);
  }
  return _objectSpread(_objectSpread({}, options), {}, {
    width: width,
    height: height,
    dprOverride: 1
  });
}
function getDpr(options, isSSR) {
  if (options.dprOverride != null && options.dprOverride > 0) {
    return options.dprOverride;
  } else if (isSSR) {
    return 1;
  } else {
    return defaultDPR;
  }
}